import { Market } from "src/state/master-data/state-models/market";
import { ProductionPriceCondition } from "./production-price-condition";
import { ComponentType } from "src/state/master-data/state-models/component-type";
import { ProductCalculationType } from "./product-price-calculation-type";


export interface ProductionPriceList {


    id: number;
    description: string;
    componentType: ComponentType;
    market: Market;
    productCalculationType :ProductCalculationType;
    productionPriceCondition?: ProductionPriceCondition[];
}

export interface ProductionPriceListForm {
    id: number;
    description: string;
}

export interface ImportPriceListExcel {
    priceListId: number;
    componentType: string;
    condition: number;
    conditionDescription: string
    importedPriceListVariantDetails: ImportedPriceListVariantDetail[];
    price: number;
    priceType: string;
    validFrom: Date;
    validTo: Date;
    errorMessage: string[];
    market: string;
}

export interface ImportedPriceListVariantDetail {
    variantClass: string;
    variantFamily: string;
    variantOption: string;
    variantOptionId?: number;
    variantFamilyId?: number;
}
